import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user
  },
  state: {
    tabs: ['首页'],
    tendertitte: '',
    avatar: '../../assets/images/userCenter/avatar.png',
  },
  getters: {
    tabs: state => state.tabs,
    tendertitte: state => state.tendertitte,
    avatar: state => {state.avatar = user.state.avatar !== 'undefined' ? user.state.avatar : state.avatar; return state.avatar},
  },
  mutations: {
    SET_TENDERTITTLE: (state, payload) => {
      state.tendertitte = payload
    },
    SET_TABS: (state, payload) => {
      state.tabs[2] = payload
      state.tabs = state.tabs.concat([])
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js